module.exports = __webpack_public_path__ + "static/img/2.bca6d5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/12/zh/2.png
// module id = ykva
// module chunks = 0